/* lv-prezent-lp (29.10.2026): LP "Na prezent" - zakladki budzetu, "Pokaz wiecej" w siatkach, skroty do zakladek.
   Bez JS strona pokazuje wszystkie panele i wszystkie produkty (klasa pz-js wlacza zwijanie). */
(function () {
  function init(root) {
    if (root.dataset.pzGotowe) return;
    root.dataset.pzGotowe = '1';
    root.classList.add('pz-js');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pz-zakladki] [role="tab"]'));
    var panele = Array.prototype.slice.call(root.querySelectorAll('[data-pz-panel]'));
    function wybierz(i, fokus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panele[k]) panele[k].hidden = !on;
      });
      if (fokus && tabs[i]) tabs[i].focus();
    }
    if (tabs.length) {
      wybierz(0, false);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { wybierz(i, false); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
            wybierz(n, true);
          }
        });
      });
    }
    root.querySelectorAll('[data-pz-tab-link]').forEach(function (a) {
      a.addEventListener('click', function () { wybierz(Number(a.dataset.pzTabLink) || 0, false); });
    });
    root.querySelectorAll('[data-pz-wiecej]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = b.closest('.pz-in');
        if (!box) return;
        var otw = box.classList.toggle('pz-otwarte');
        b.setAttribute('aria-expanded', otw ? 'true' : 'false');
        if (!b.dataset.pzTekst) b.dataset.pzTekst = b.textContent;
        b.textContent = otw ? 'Zwiń listę' : b.dataset.pzTekst;
      });
    });
  }
  function start() { document.querySelectorAll('[data-pz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
